import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import toast, { Toaster } from "react-hot-toast";
import UndoCancelToast from "@/components/toasts/undo-cancel/undo-cancel-toast";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import { useEffect } from "react";
import { isExpiredSoonDate } from "@/utils/undo-cancel";
import { $undoCancelKey } from "@/data/undo-cancel.constants";
import { useABTestUndoCancelContext } from "@/providers/ab-testing-providers/ab-test-undo-cancel-provider";

export const useUndoCancel = () => {
  const { showModal } = useGlobalModalContext();
  const { subscription, isLoading } = useProfileContext();
  const { experiment, fetchExperiment, user } = useABTestUndoCancelContext();

  const isInCurrentMonth = (): boolean => {
    try {
      const storedValue = localStorage.getItem($undoCancelKey);
      if (!storedValue) {
        return false;
      }

      const parsedDate = new Date(Number(storedValue));
      if (isNaN(parsedDate.getTime())) {
        return false;
      }

      const currentDate = new Date();

      return (
        parsedDate.getFullYear() === currentDate.getFullYear() &&
        parsedDate.getMonth() === currentDate.getMonth()
      );
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (!experiment || !user) {
      return;
    }

    if (isInCurrentMonth()) {
      return;
    }

    if (isLoading) {
      return;
    }

    if (!subscription?.cancelAt || !isExpiredSoonDate(subscription.cancelAt)) {
      return;
    }

    fetchExperiment(experiment, user).then((variant) => {
      if (variant === "modal") {
        showModal({
          type: "undo-cancel-modal",
        });
        return;
      }

      toast(
        (t) => {
          return (
            <UndoCancelToast
              close={() => {
                toast.dismiss(t.id);
              }}
            />
          );
        },
        {
          duration: 999999,
          position: "bottom-center",
          style: {
            backgroundColor: "transparent",
            width: "100%",
            maxWidth: "100%",
            padding: "0",
          },
        },
      );
    });
  }, [isLoading, experiment, user]);

  return {
    Toaster,
  };
};
